import _taggedTemplateLiteral from "babel-runtime/helpers/taggedTemplateLiteral";
import _objectWithoutProperties from "babel-runtime/helpers/objectWithoutProperties";

var _templateObject = _taggedTemplateLiteral(["\n    padding: 7px; 0;\n  "], ["\n    padding: 7px; 0;\n  "]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row-reverse;\n  overflow: hidden;\n  vertical-align: top;\n  width: 100%;\n  > .Label {\n    ", ";\n    color: #fff;\n    display: inline-block;\n    flex: 1;\n    padding: 2px 0;\n    position: relative;\n  }\n  > .Field {\n    width: 25px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row-reverse;\n  overflow: hidden;\n  vertical-align: top;\n  width: 100%;\n  > .Label {\n    ", ";\n    color: #fff;\n    display: inline-block;\n    flex: 1;\n    padding: 2px 0;\n    position: relative;\n  }\n  > .Field {\n    width: 25px;\n  }\n"]);

import React from "react";
import styled from "styled-components";
import { withProps } from "recompose";

import { get, mixin, toggle, bigPhone } from "../../style/util";

import Button from "../../components/Button";

var Form = styled(function (_ref) {
  var loading = _ref.loading,
      props = _objectWithoutProperties(_ref, ["loading"]);

  return React.createElement("form", props);
}).withConfig({
  componentId: "d9xjas-0"
})(["color:", ";display:flex;align-items:stretch;flex-direction:column;justify-content:stretch;margin:20px 0;position:relative;", ";"], get('color.standard'), toggle("loading", "\n    cursor: wait;\n    opacity: 0.33;\n    pointer-events: none;\n  "));

export { Form };
export var FormProperty = styled(function FormProperty(_ref2) {
  var label = _ref2.label,
      required = _ref2.required,
      hasFocus = _ref2.hasFocus,
      hasValue = _ref2.hasValue,
      className = _ref2.className,
      children = _ref2.children;

  return React.createElement(
    "label",
    {
      className: [className, hasFocus || hasValue ? "focus" : ""].join(" ")
    },
    React.createElement(
      "span",
      { className: "Label" },
      label,
      !!required && " *"
    ),
    React.createElement(
      "span",
      { className: "Field" },
      children
    )
  );
}).withConfig({
  componentId: "d9xjas-1"
})(["margin:0;padding:5px 0;", ";> .Label{", ";display:block;padding:10px 20px;pointer-events:none;position:absolute;transition:all 0.25s ease;z-index:100;}> .Field{input,select{", ";background-color:#fff;border:0;border-radius:8px;box-sizing:border-box;padding:10px 20px;position:relative;transition:all 0.25s ease;width:100%;z-index:1;}select{appearance:none;padding-right:40px;}}&.focus{> .Label{", ";opacity:0.5;padding-top:5px;padding-bottom:0;}> .Field{input,select{padding-bottom:5px;padding-top:15px;}}}"], bigPhone(_templateObject), mixin("font.bold", 16), mixin("font.default", 16), mixin("font.bold", 10, "10px"));

export var FormCheckbox = FormProperty.extend(_templateObject2, mixin("font.default", 13));

export var SubmitButton = styled(withProps({ primary: true, backgroundColor: "#FFF", textColor: "#000" })(Button)).withConfig({
  componentId: "d9xjas-2"
})(["display:inline-block;margin:10px 75px;padding-left:0;padding-right:0;"]);

export var ErrorText = styled.p.withConfig({
  componentId: "d9xjas-3"
})(["", ";background:", ";border-radius:8px;color:", ";margin:5px 0;padding:10px 15px;"], mixin("font.bold", 16), get("color.error"), get("color.errorText"));

export var Text = styled.p.withConfig({
  componentId: "d9xjas-4"
})(["", ";color:", ";margin:0.5em auto;padding:0;text-align:center;"], mixin("font.default", 13), get("color.successText"));
//# sourceMappingURL=style.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/pages/Registration/style.js
// module id = 465
// module chunks = 0